"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getStaticVersionNumber = getStaticVersionNumber;
exports.precacheCRMAssets = precacheCRMAssets;
exports.precacheCRMRuntimeAssets = precacheCRMRuntimeAssets;
exports.stopVersionPoll = stopVersionPoll;
exports.startCRMAssetPoll = startCRMAssetPoll;
exports.maybeStartCRMAssetPoll = maybeStartCRMAssetPoll;
exports.CRM_ASSET_CACHE = exports.CRM_RUNTIME_ASSET_PATH = exports.CRM_ASSET_PATH = void 0;

var _AssetVersionAPI = require("crm_data/assets/AssetVersionAPI");

var _hubspot = _interopRequireDefault(require("hubspot.bender"));

var _ObjectTypes = require("customer-data-objects/constants/ObjectTypes");

var _loggers = require("customer-data-tracking/loggers");

var _CrmPrecacheNamespace = _interopRequireDefault(require("hublabs-experiments/namespaces/CrmPrecacheNamespace"));

var CRM_ASSET_PATH = 'https://static.hsappstatic.net/crm_ui';
exports.CRM_ASSET_PATH = CRM_ASSET_PATH;
var CRM_RUNTIME_ASSET_PATH = 'https://static.hsappstatic.net/crm_runtime';
exports.CRM_RUNTIME_ASSET_PATH = CRM_RUNTIME_ASSET_PATH;
var CRM_ASSET_CACHE = 'crm-asset-v1';
exports.CRM_ASSET_CACHE = CRM_ASSET_CACHE;
var ALL_CRM_ASSETS = ['js/crm-main.js', 'sass/CRM.css'];
var ALL_CRM_RUNTIME_ASSETS = ['bundles/runtime.production.js'];
var intervalTimer = 1000 * 60 * 30; // 30 Mins

var fetchVersionInterval;
var lastCachedCRMVersion;
var lastCachedRuntimeVersion;

function prefetchAsset(staticDomain, buildVersion, assetPath) {
  var prefetchLink = document.createElement('link');
  prefetchLink.href = staticDomain + "/static-" + buildVersion + "/" + assetPath;
  prefetchLink.rel = 'prefecth';
  prefetchLink.as = 'script';
  prefetchLink.crossorigin = 'anonymous';
  document.head.appendChild(prefetchLink);
}

function getStaticVersionNumber(versionString) {
  if (versionString.indexOf('static-') === 0) {
    return versionString.split('static-')[1];
  }

  return 'static';
}

function precacheCRMAssets(buildVersion) {
  ALL_CRM_ASSETS.forEach(function (assetPath) {
    prefetchAsset(CRM_ASSET_PATH, buildVersion, assetPath);
  });
}

function precacheCRMRuntimeAssets(buildVersion) {
  ALL_CRM_RUNTIME_ASSETS.forEach(function (assetPath) {
    prefetchAsset(CRM_RUNTIME_ASSET_PATH, buildVersion, assetPath);
  });
}

function stopVersionPoll() {
  clearInterval(fetchVersionInterval);
}

function startCRMAssetPoll() {
  if (fetchVersionInterval) {
    stopVersionPoll();
  }

  var currentCRMVersion = getStaticVersionNumber(_hubspot.default.currentProjectVersion);
  var currentRuntimeVersion = getStaticVersionNumber(_hubspot.default.depVersions.crm_runtime);
  fetchVersionInterval = setInterval(function () {
    (0, _AssetVersionAPI.fetchVersion)().then(function (staticConf) {
      var crmVersion = staticConf.get('build');
      var runtimeVersion = staticConf.getIn(['deps', 'crm_runtime']);
      var isLocal = currentCRMVersion === 'static' || crmVersion === 'dev';

      if (isLocal) {
        stopVersionPoll();
      }

      if (!isNaN(crmVersion) && !isNaN(currentCRMVersion) && crmVersion !== currentCRMVersion && crmVersion !== lastCachedCRMVersion) {
        precacheCRMAssets(crmVersion);
        lastCachedCRMVersion = crmVersion;

        _loggers.CrmLogger.logInternal(_ObjectTypes.CONTACT, {
          cachedVersion: crmVersion,
          asset: 'crm-main'
        });
      }

      if (!isNaN(runtimeVersion) && !isNaN(currentRuntimeVersion) && runtimeVersion !== currentRuntimeVersion && runtimeVersion !== lastCachedRuntimeVersion) {
        precacheCRMRuntimeAssets(runtimeVersion);
        lastCachedRuntimeVersion = runtimeVersion;

        _loggers.CrmLogger.logInternal(_ObjectTypes.CONTACT, {
          cachedVersion: runtimeVersion,
          asset: 'crm-runtime'
        });
      }
    }).catch(function () {
      stopVersionPoll();
    });
  }, intervalTimer);
}

function maybeStartCRMAssetPoll() {
  var shouldPrecache = _CrmPrecacheNamespace.default.get('shouldPrecache');

  if (shouldPrecache === 1) {
    startCRMAssetPoll();

    if (window.newrelic) {
      window.newrelic.setCustomAttribute('precaching-enabled', true);
      window.newrelic.setCustomAttribute('precaching-expriement', true);
    }
  } else if (shouldPrecache === 0) {
    if (window.newrelic) {
      window.newrelic.setCustomAttribute('precaching-enabled', false);
      window.newrelic.setCustomAttribute('precaching-expriement', false);
    }
  }
}